import { getBaseApiUrl, getConfirmationModalConfig, resolveApiErrorMessage } from 'utils';
import { getLtiTrainingSessionLaunchPreflight } from 'http/moodle';

export const openLtiTrainingSession = async ({ trainingSessionId, t, dispatch, modalActions }) => {
  const preflight = await getLtiTrainingSessionLaunchPreflight(trainingSessionId);
  if (preflight?.error || preflight?.statusCode) {
    const closeModal = () => dispatch(modalActions.closeModal());
    const [config, element] = getConfirmationModalConfig({
      confirmTitle: t('buttons.ok'),
      confirmAction: closeModal,
      rejectAction: closeModal,
      message: resolveApiErrorMessage(preflight?.message, {
        t,
        fallbackMessage: t('errors.serverError'),
      }),
    });
    dispatch(modalActions.openModal(config, element));
    return;
  }

  const baseURL = getBaseApiUrl();
  window.open(`${baseURL}/lti/launch-training-session?trainingSessionId=${trainingSessionId}`, '_blank');
};
